// extracted by mini-css-extract-plugin
module.exports = {"loader":"application-loader_loader__YHL__"};